// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".swiper-slide[data-v-7913ea5e]{width:21rem;min-width:50%}", ""]);
// Exports
module.exports = exports;
